import { render, staticRenderFns } from "./ApproveList.vue?vue&type=template&id=81f1a570&scoped=true"
import script from "./ApproveList.vue?vue&type=script&lang=js"
export * from "./ApproveList.vue?vue&type=script&lang=js"
import style0 from "./ApproveList.vue?vue&type=style&index=0&id=81f1a570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f1a570",
  null
  
)

export default component.exports